mutation CHATBOT_VOTE (
  $messageId: UUID!,
  $vote: ChatMessageVoteEnum
) {
  chatMessageVote (
    messageId: $messageId
    vote: $vote
  ) {
      success
      error
    }
}
